export const divider = {
  base: {
    borderBottom: ".0625rem",
    borderBottomStyle: "dashed",
    borderColor: "accent3",
    height: "1px",
    margin: "1.25rem 0"
  }
};
